export default __webpack_public_path__ + "static/media/BermSlope.3268dfe1.png";